<!--
 * @Author: Niklaus
 * @Date: 2025-08-14 17:20:22
 * @LastEditTime: 2026-03-12 09:40:51
 * @LastEditors: Niklaus
 * @Description: 实收费用明细
-->
<template>
  <basic-container isCard :body-style="{ padding: '0', height: '100%' }" class="h-100p">
    <el-form :inline="true" :model="formInline" size="small" class="demo-form-inline">
      <el-form-item label="时间">
        <el-date-picker class="w-150" v-model="formInline.startDate" placeholder="开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="-" width="300px">
        <el-date-picker class="w-150" v-model="formInline.endDate" placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTime('W')">上周实收</el-button>
        <el-button type="primary" @click="getTime('M')">本月实收</el-button>
        <el-button type="primary" @click="getTime('Y')">本年度实收</el-button>
        <el-button type="primary" @click="onLoad">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="h-100p">
      <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" :page.sync="page" @on-load="onLoad"
        @search-change="searchChange" @refresh-change="onLoad()" class="custom">
      </avue-crud>

    </div>
  </basic-container>
</template>
<script>
import dayjs, { Dayjs } from "dayjs"
import { getWeek } from '@/util/date'
import { getMetaCommonList, getMetaListUrl } from '@/api/busiMode/metaCommon';
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      query: {},
      size: '60%',
      page: {
        size: 10,
        current: 1,
        total: 0,
      },
      formInline: {
        startDate: "",
        endDate: "",
      },
      option: {
        dateBtn: false,
        border: true,
        height: 'auto',
        tip: true,
        searchShowBtn: false,
        searchMenu: false,
        searchShow: false,
        addBtn: false,
        refreshBtn: false,
        addRowBtn: false,
        columnBtn: false,
        rowKey: '',
        showPage: true,
        index: true,
        indexLabel: '序号',
        selection: false,
        showHeader: true,
        expand: false,
        highlightCurrentRow: true,
        stripe: false,
        menu: false,
        column: [
          {
            align: 'left',
            label: '合同编号',
            prop: 'contract_code',
            width: 250,
          },

          {
            align: 'left',
            label: '账单编号',
            prop: 'receipt_no',
          },
          {
            align: 'left',
            label: '应收金额',
            prop: 'amount_receivable',
          },
          {
            align: 'left',
            label: '实收金额',
            prop: 'amount_received',
          },
          {
            align: 'left',
            label: '减免金额',
            prop: 'redu_amount_received',
          },
          {
            align: 'left',
            label: '账单开始时间',
            prop: 'period_start_time',
          },
          {
            align: 'left',
            label: '账单结束时间',
            prop: 'period_end_time',
          },

          {
            label: "缴费时间",
            prop: "success_time",
            showColumn: true,
            type: "date",
          },

        ],
      },
      model: 'wisdom_park.v_rpt_buil_cont_rece_paym_curyear',
      data: [],
      query: {
        success_time: getWeek(-1),
      },
    };
  },
  methods: {
    searchChange(params, done) {
      this.query = params;
      this.onLoad();
      done();
    },
    onLoad() {
      this.loading = true;
      let body = {
        current: this.page.currentPage || 1,
        size: this.page.pageSize || 10,
        orders: [{ field: "success_time", sort: "DESC" }],
        wheres: []
      };
      if (this.formInline.startDate && this.formInline.endDate) {
        body.wheres.push(
          { field: 'success_time', op: 'GE', value: this.formInline.startDate },
          { field: 'success_time', op: 'LE', value: this.formInline.endDate }
        );
      }
      getMetaCommonList(this.model, body).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
      });
    },

    getTime(type) {
      if (type == 'W') {
        let t = getWeek(-1)
        if (t && t.length > 0) {
          this.formInline.startDate = t[0]
          this.formInline.endDate = t[1]
        }
      } else if (type == 'M') {
        this.formInline.startDate = dayjs().startOf('month').format('YYYY-MM-DD')
        this.formInline.endDate = dayjs().endOf('month').format('YYYY-MM-DD')
      } else if (type == 'Y') {
        let y = dayjs().year()
        this.formInline.startDate = y + '-01-01'
        this.formInline.endDate = y + '-12-31'
      }
      this.onLoad()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom .avue-crud__menu {
  display: none !important;
  height: 0;
  min-height: 0;
}

.demo-form-inline {
  padding: 20px 15px 0 20px;
}
</style>
